import React from 'react';
import { ApprovalStatus } from '../types';
import {
    faCheck,
    faCross,
    faExclamation,
    faX,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ApprovalCheckBoxProps {
    status?: ApprovalStatus;
}

// Map of approval status to styling and icon information
const STATUS_CONFIG = {
    [ApprovalStatus.APPROVED]: { className: 'green', icon: faCheck },
    [ApprovalStatus.REJECTED]: { className: 'red', icon: faX },
    [ApprovalStatus.REFERRED]: { className: 'yellow', icon: faExclamation },
};

const ApprovalCheckBox: React.FC<ApprovalCheckBoxProps> = ({ status }) => {
    // Get configuration based on status or use default values
    const config = status
        ? STATUS_CONFIG[status]
        : { className: 'empty', icon: null };

    return (
        <div className={`approval-checkbox ${config.className}`}>
            {config.icon && <FontAwesomeIcon icon={config.icon} />}
        </div>
    );
};

export default ApprovalCheckBox;
